import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/uicomponentcss';
import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';

export interface BlackListRowCSSStyle extends UIComponentCSSStyle
{
  
    getBlacklistNameDivCSSStyle():object;
    getBlacklistNameLabelCSSStyle():object;
    getMSISDNLabelCSSStyle():object;
    getDeleteImgDivCSSStyle():object;
    getDeleteImgCSSStyle():object;
}

export class  BlackListRowCSSStyleImpl extends UIComponentCSSStyleImpl implements BlackListRowCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width:"100%",
            borderRadius:'6px',
            marginTop:'10px',
            height:'60px',
            display:'flex',
            border:' 1px solid #EAECEF',
             flexDirection:'row',
             backgroundColor:this.getResources().getColor(Colors.color_5), 
             boxShadow: "0 2px 10px 0 rgba(0,0,0,0.07)",
             flexFlow: "row wrap",
             fontFamily:this.getContext().getResources().getFontFamily(),
            //  marginLeft:'20%',
            //  marginRight:'20%'
           
        };
    }

    getBlacklistNameDivCSSStyle():object
    {
        return{
            width:'92%', height:'100%',
        };
    }
  

    getBlacklistNameLabelCSSStyle():object
    {
        return{
            width:'100%',
            textAlign:'left',
            margin:'10px 0px 0px 30px',
            height:'20px', 
            lineHeight:'20px', 
            color:'#6D6D6D',
            fontSize:'15px',
            letterSpacing:'0',
            fontWeight:"500",
            fontFamily:this.getContext().getResources().getFontFamily(),

        };
    }

    getMSISDNLabelCSSStyle():object
    {
        return{
            width:'100%',fontSize:'15px',textAlign:'left',
            margin:'0px 0px 0px 30px',
            height:'20px',
            fontFamily:this.getResources().getFontFamily(),
            fontWeight:500, lineHeight:'20px',marginBottom:'10px',color:'#221E20',marginLeft:'30px'
        };
    }

   

    getDeleteImgDivCSSStyle():object{
        return{
            width:'8%',align:'center',borderLeft:' 1px solid #EAECEF',height:'100%',borderRadius:'0px 6px 6px 0px'
        };
    }
   
   
   
    getDeleteImgCSSStyle():object
    {
        return{
            marginTop:'20.7px',cursor:'pointer',
        };
    }

   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/blacklisting/viewmodel/blacklistrowcss.tsx